export function toApiSort(sort?: string[]): string | undefined {
  if (sort && sort.length > 0) {
    return sort.join(',');
  }
  return undefined;
}
